import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { ROUTES } from '@/core/config/routes';
import { ForgotRequestSchema } from '@/data/dto/auth';
import { useForgotPassword } from '@/data/hooks/useAuth';
import { Button } from '@/shared/components/Button';
import { Field } from '@/shared/components/Field';
import { Input } from '@/shared/components/Input';
export function ForgotPasswordForm() {
    const [enviado, setEnviado] = useState(false);
    const { register, handleSubmit, formState: { errors }, } = useForm({
        resolver: zodResolver(ForgotRequestSchema),
        defaultValues: { email: '' },
    });
    const { mutate, isPending } = useForgotPassword();
    const onSubmit = (datos) => {
        // siempre mostramos el mensaje de éxito, aunque el backend devuelva error,
        // para evitar enumeración de usuarios
        mutate(datos, {
            onSettled: () => setEnviado(true),
        });
    };
    if (enviado) {
        return (_jsxs("div", { className: "flex flex-col items-center gap-3 text-center", children: [_jsx(CheckCircle2, { className: "h-10 w-10 text-success", strokeWidth: 1.5 }), _jsx("h2", { className: "text-lg font-semibold text-text-primary", children: "Revis\u00E1 tu bandeja de entrada" }), _jsx("p", { className: "text-sm text-text-secondary", children: "Si ese email est\u00E1 registrado, te enviamos un enlace para restablecer tu contrase\u00F1a. Puede tardar unos minutos en llegar." }), _jsx(Link, { to: ROUTES.login, className: "mt-2 text-sm font-medium text-primary hover:underline", children: "Volver al inicio de sesi\u00F3n" })] }));
    }
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "flex flex-col gap-4", noValidate: true, children: [_jsx(Field, { label: "Email", htmlFor: "email", error: errors.email?.message, required: true, children: _jsx(Input, { id: "email", type: "email", autoComplete: "username", autoFocus: true, error: Boolean(errors.email), ...register('email') }) }), _jsx(Button, { type: "submit", cargando: isPending, size: "lg", className: "w-full", children: "Enviar enlace" }), _jsx("div", { className: "text-center", children: _jsx(Link, { to: ROUTES.login, className: "text-sm font-medium text-primary hover:underline", children: "Volver al inicio de sesi\u00F3n" }) })] }));
}
